(() => {
  const init = () => {
    document.querySelectorAll('.collapsible-trigger[aria-controls]').forEach(button => {
      if(button.dataset.luxeBound)return;
      button.dataset.luxeBound='true';
      button.setAttribute('aria-expanded','false');
      button.addEventListener('click',()=>{
        const content=document.getElementById(button.getAttribute('aria-controls'));
        if(!content)return;
        const open=button.getAttribute('aria-expanded')!=='true';
        button.setAttribute('aria-expanded',String(open));
        button.classList.toggle('is-open',open);
        content.classList.toggle('is-open',open);
      });
    });
    const search=document.querySelector('.site-header__search-container');
    document.querySelectorAll('.js-search-header').forEach(button=>button.addEventListener('click',event=>{
      event.preventDefault();search?.classList.add('luxe-search-open');search?.querySelector('input[type="search"]')?.focus();
    }));
    document.querySelectorAll('.js-search-header-close').forEach(button=>button.addEventListener('click',()=>search?.classList.remove('luxe-search-open')));
    let overlay=document.querySelector('.luxe-drawer-overlay');
    if(!overlay){overlay=document.createElement('div');overlay.className='luxe-drawer-overlay';document.body.appendChild(overlay);}
    const close=()=>{
      document.querySelectorAll('.drawer').forEach(drawer=>drawer.classList.remove('drawer--is-open'));
      overlay.classList.remove('is-open');document.body.classList.remove('js-drawer-open');
    };
    document.querySelectorAll('.js-drawer-open-nav').forEach(button=>button.addEventListener('click',()=>{
      close();document.getElementById('NavDrawer')?.classList.add('drawer--is-open');overlay.classList.add('is-open');document.body.classList.add('js-drawer-open');
    }));
    const cartDrawer = document.getElementById('CartDrawer');
    const cartForm = cartDrawer?.querySelector('form');
    if (cartForm && !cartForm.dataset.luxeCartBound) {
      cartForm.dataset.luxeCartBound = 'true';
      const root = window.Shopify?.routes?.root || '/';
      const products = cartForm.querySelector('[data-products]');
      const delivery = cartForm.querySelector('.cartx-trust__img + span');
      if (delivery) delivery.textContent = 'Free Delivery';
      let pending = false;
      const request = async (path, body) => {
        const response = await fetch(root + path, body ? (body instanceof FormData ? { method: 'POST', body } : { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }) : {});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to update the cart. Please try again.');
        return data;
      };
      const open = () => {
        close();
        cartDrawer.classList.add('drawer--is-open');
        overlay.classList.add('is-open');
        document.body.classList.add('js-drawer-open');
        cartDrawer.querySelector('.js-drawer-close')?.focus();
      };
      const productPrices = new Map();
      const comparePrice = item => {
        if (!productPrices.has(item.handle)) {
          const prices = request('products/' + encodeURIComponent(item.handle) + '.js');
          productPrices.set(item.handle, prices);
          prices.catch(() => productPrices.delete(item.handle));
        }
        return productPrices.get(item.handle).then(product => product.variants.find(variant => variant.id === item.variant_id)?.compare_at_price || 0);
      };
      const render = cart => {
        const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(amount / 100);
        const make = (tag, text, className) => {
          const element = document.createElement(tag);
          if (text) element.textContent = text;
          if (className) element.className = className;
          return element;
        };
        products.replaceChildren(...cart.items.map((item, index) => {
          const row = make('div', '', 'cart__item');
          const image = make('img');
          image.alt = '';
          if (item.image) image.src = item.image;
          image.width = image.height = 90;
          const imageLink = make('a', '', 'cart__image');
          imageLink.href = item.url;
          imageLink.append(image);
          const details = make('div', '', 'cart__item-details');
          const title = make('a', item.product_title, 'cart__item-name');
          title.href = item.url;
          details.append(title);
          if (item.variant_title) details.append(make('div', item.variant_title, 'cart__item--variants'));
          const controls = make('div', '', 'cart__item-sub');
          const quantity = make('div', '', 'js-qty__wrapper');
          const button = (label, accessibleName, value) => {
            const control = make('button', label, 'btn btn--secondary');
            control.type = 'button';
            control.setAttribute('aria-label', accessibleName);
            control.addEventListener('click', () => update('cart/change.js', { line: index + 1, quantity: value }, control));
            return control;
          };
          quantity.append(button('−', 'Decrease quantity', item.quantity - 1), make('span', String(item.quantity)), button('+', 'Increase quantity', item.quantity + 1));
          const prices = make('div');
          prices.style.textAlign = 'right';
          const showPrice = original => {
            prices.replaceChildren();
            const saved = original - item.final_line_price;
            if (saved > 0) prices.append(make('s', money(original)), document.createTextNode(' '));
            prices.append(make('strong', money(item.final_line_price)));
            if (saved > 0) {
              const savings = make('div', '(Saved ' + money(saved) + ')');
              savings.style.color = '#378044';
              savings.style.fontWeight = '600';
              prices.append(savings);
            }
          };
          showPrice(item.original_line_price);
          comparePrice(item).then(price => showPrice(Math.max(item.original_line_price, price * item.quantity))).catch(() => {});
          controls.append(quantity, prices);
          details.append(controls, button('Remove', 'Remove ' + item.product_title, 0));
          row.append(imageLink, details);
          return row;
        }));
        cartDrawer.classList.toggle('is-empty', !cart.item_count);
        cartDrawer.querySelector('.drawer__cart-empty').hidden = Boolean(cart.item_count);
        cartDrawer.querySelector('.drawer__footer').hidden = !cart.item_count;
        document.querySelectorAll('.cart-link__bubble-num').forEach(count => count.textContent = String(cart.item_count));
        cartForm.querySelectorAll('[data-subtotal], [data-second_sub_ttl]').forEach(total => total.textContent = money(cart.total_price));
      };
      const update = async (path, data, control) => {
        if (pending) return;
        pending = true;
        if (control) control.setAttribute('aria-busy', 'true');
        try {
          let cart = await request(path, data);
          if (!Array.isArray(cart.items)) cart = await request('cart.js');
          render(cart);
          if (!cartDrawer.classList.contains('drawer--is-open')) open();
        } catch (error) {
          window.alert(error.message);
        } finally {
          pending = false;
          control?.removeAttribute('aria-busy');
        }
      };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('.js-drawer-open-cart');
        if (!trigger) return;
        event.preventDefault();
        update('cart.js', null, trigger);
      });
      document.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('.luxe-product-form')) return;
        event.preventDefault();
        update('cart/add.js', new FormData(form), event.submitter);
      });
    }
    document.querySelectorAll('.js-drawer-close').forEach(button=>button.addEventListener('click',close));
    overlay.addEventListener('click',close);
    document.addEventListener('keydown',event=>{if(event.key==='Escape'){close();search?.classList.remove('luxe-search-open');}});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
